import { Link, Outlet } from 'react-router-dom';
import { ROLE_LABELS } from '@swg/domain';
import { logout } from '../api.js';
import { theme } from '../theme.js';
import { useUser } from '../user-context.js';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function AppShell() {
  const user = useUser();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header
        style={{
          background: theme.color.surface,
          borderBottom: `1px solid ${theme.color.border}`,
          padding: '0 28px',
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 20,
        }}
      >
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none' }}>
          <img src="/assets/schoonderwolf-logo.svg" alt="Schoonderwolf" style={{ height: 36, display: 'block' }} />
          <span
            style={{
              color: theme.color.muted,
              fontSize: 13,
              borderLeft: `1px solid ${theme.color.border}`,
              paddingLeft: 14,
              fontWeight: 500,
            }}
          >
            Geautomatiseerde concurrentieanalyse
          </span>
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          {user.role === 'ADMIN' && (
            <Link to="/users" style={{ fontSize: 13, fontWeight: 600, color: theme.color.primary }}>
              Gebruikers
            </Link>
          )}
          <div style={{ textAlign: 'right', lineHeight: 1.25 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>{user.displayName}</div>
            <div style={{ fontSize: 11.5, color: theme.color.muted }}>{ROLE_LABELS[user.role]}</div>
          </div>
          <div
            title={user.email}
            style={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              background: theme.color.accentBg,
              color: theme.color.primary,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 12.5,
              fontWeight: 600,
            }}
          >
            {initials(user.displayName)}
          </div>
          <button
            onClick={() => void logout()}
            style={{
              background: 'transparent',
              border: `1px solid ${theme.color.borderStrong}`,
              borderRadius: 8,
              padding: '6px 12px',
              fontSize: 12.5,
              fontWeight: 600,
              color: theme.color.text,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            Uitloggen
          </button>
        </div>
      </header>

      <main style={{ flex: 1, padding: '28px', maxWidth: 1360, width: '100%', margin: '0 auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
